import { Paper } from "@mui/material";
import { useState } from "react";
import Base from "../../../Base/views/Base";
import PropTypes from 'prop-types';
import EmployeeBulkUpload from "./EmployeeBulkUpload";

// const styles = `
//   @keyframes fadeIn {
//     from {
//       opacity: 0;
//       transform: translateY(10px);
//     }
//     to {
//       opacity: 1;
//       transform: translateY(0);
//     }
//   }
// `;

const EmployeeBulkUploadLandingPage = () => {
  const [, setValue] = useState(0);


  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        style={{ 
          transition: 'opacity 0.2s ease-in-out',
          opacity: value === index ? 1 : 0
        }}
      >
        {value === index && (
          <Paper sx={{ borderRadius: "10px" }}>
            {children}
          </Paper>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  // function a11yProps(index) {
  //   return {
  //     id: `simple-tab-${index}`,
  //     'aria-controls': `simple-tabpanel-${index}`,
  //   };
  // }

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  return (
    <Base>
      <EmployeeBulkUpload onNavigateToImageUpload={() => setValue(1)} />
      {/* <style>{styles}</style>
      <Box sx={{ height: "87vh", display: "flex", flexDirection: "column" }}>
        <Box sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 10 }}>
          <Tabs 
            value={value} 
            onChange={handleChange} 
            aria-label="basic tabs example" 
            sx={{
              mb: 1,
              '& .MuiTabs-indicator': {
                transition: 'all 0.8s ease-in-out',
              }
            }}
            variant="scrollable"
            orientation="horizontal"
            allowScrollButtonsMobile={true}
            TabIndicatorProps={{
              style: {
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }
            }}
          >
            <Tab label="Employee Bulk Upload" {...a11yProps(0)} />
            <Tab label="Employee Image Bulk Upload" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <Box sx={{ flex: 1, overflowY: "auto", scrollBehavior: "smooth" }}>
          <TabPanel value={value} index={0}>
            <EmployeeBulkUpload onNavigateToImageUpload={() => setValue(1)} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <EmployeePicUpload />
          </TabPanel>
        </Box>
      </Box> */}
    </Base>
  );
};

export default EmployeeBulkUploadLandingPage;
